import { Paper, Typography } from '@mui/material';

// 风控预警分析卡片
export default function AiAnalysisCard({ title, titleColor, content }: Props) {
    return (
        <Paper
            sx={{
                borderRadius: '16px',
                padding: '16px 8px',
                textAlign: 'center',
                boxShadow: 'none'
            }}
        >
            <Typography
                variant='body1'
                className={titleColor}
                sx={{
                    mb: 4,
                    textAlign: 'center'
                }}
            >
                {title}
            </Typography>
            {content}
        </Paper >
    )
}

type Props = {
    title: string;
    content: JSX.Element;
    titleColor: 'info' | 'success' | 'primary' | 'error'
}